<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText="Fee Types"
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="miscellaneousFees"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.search_fee_applicable`]="{ value }">
              <v-simple-checkbox :value="value" disabled></v-simple-checkbox>
            </template>
            <template #[`item.postal_fee_applicable`]="{ value }">
              <v-simple-checkbox :value="value" disabled></v-simple-checkbox>
            </template>
            <template #[`item.student_status`]="{ value }">
              <div v-if="value && value.length" class="d-flex flex-wrap">
                <v-chip
                  v-for="status in value"
                  :key="status"
                  small
                  class="ma-1"
                  :color="statusColor(status)"
                  outlined
                >
                  {{ getStudentStatusLabel(status) }}
                </v-chip>
              </div>

              <span v-else class="grey--text text--lighten-1">-</span>
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item.active) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <FeeTypeFormDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createFeeType"
        @update="updateFeeType"
        :miscellaneousFee="miscellaneousFee"
        :edit="editMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="fee type"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import FeeTypeFormDialog from "@/components/miscellaneousFee.vue";
import searchBar from "@/components/searchBar.vue";
import { miscellaneousFeeHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";

export default {
  components: {
    FeeTypeFormDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      miscellaneousFee: {},
      currentItem: {},
      showDialog: false,
      miscellaneousFees: [],
      search: "",
      headers: miscellaneousFeeHeaders,
    };
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Miscellaneous Fee" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.getMiscellaneousFees();
    },
    async getMiscellaneousFees() {
      await this.$axios
        .get("miscellaneous_fees")
        .then((res) => {
          this.miscellaneousFees = res.data.data.sort((a, b) => a.id - b.id);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message:
              error.response?.data?.message ||
              "Failed to fetch fee configuration",
            color: "error",
          });
        });
    },
    async createFeeType(data) {
      await this.$axios
        .post("miscellaneous_fees", { miscellaneous_fee: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Fee Configuration created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateFeeType(data) {
      await this.$axios
        .put("miscellaneous_fees/" + data.id, { miscellaneous_fee: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Fee Configuration updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updateFeeType({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },
    edit(item) {
      this.miscellaneousFee = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.currentItem = {};
      this.miscellaneousFee = {};
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const activeStatus = this.showActiveStatus(item.active);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        activeStatus.toLowerCase().includes(search.toLowerCase())
      );
    },
    getStudentStatusLabel(status) {
      const map = {
        A: "Active",
        I: "Inactive",
        T: "Discontinued",
        X: "Graduated",
      };
      return map[status] || status;
    },
    statusColor(status) {
      const map = {
        A: "green",
        I: "orange",
        T: "red",
        X: "blue",
      };
      return map[status] || "grey";
    },
  },
};
</script>

<style>
/* Add any custom styles here */
</style>
